import { render, staticRenderFns } from "./KnowledgeBaseArchives.vue?vue&type=template&id=1a7348b4"
import script from "./KnowledgeBaseArchives.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports